import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import TimelineIcon from "@mui/icons-material/Timeline";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import RedeemIcon from "@mui/icons-material/Redeem";
import { Paper } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { setShouldClearQRCodeReader } from "../redux/slices/commonSlice";

export default function BottomBar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [value, setValue] = useState(0);
  const [currentLocation, setCurrentLocation] = useState();

  const MyBottomNavigationAction = styled(BottomNavigationAction)(`
  &.Mui-selected {
    color: red;
  }
`);
  useEffect(() => {
    if (location.pathname === "/home/gift-page") {
      setValue(0);
    } else if (location.pathname === "/home/qr-code-scanner") {
      setValue(1);
    } else if (location.pathname === "/home/points") {
      setValue(2);
    }
  }, [location]);

  const closeQRCodeReader = () => {
    dispatch(setShouldClearQRCodeReader(true));
  };
  return (
    <Box sx={{ width: 500 }}>
      <Paper
        sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 99 }}
        elevation={3}
      >
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
            closeQRCodeReader();
          }}
        >
          <MyBottomNavigationAction
            component={Link}
            label="Pokloni"
            icon={<RedeemIcon />}
            to="/home/gift-page"
          />
          <MyBottomNavigationAction
            component={Link}
            label="Scan QR"
            icon={<QrCodeScannerIcon />}
            to="/home/qr-code-scanner"
          />
          <MyBottomNavigationAction
            component={Link}
            label="Poeni"
            icon={<TimelineIcon />}
            to="/home/points"
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
